import React, {useEffect} from 'react';


function Learning(){

    async function getSoftware(){
        let a = document.createElement('a');
        a.href = `https://web-service.nashresra.ir/learning`;
        a.download = 'https://web-service.nashresra.ir/learning';
        // a.target= "_blank";
        a.click();
    }

    useEffect(()=>{
        getSoftware()
    },[])

    return (
        <div className="d-flex justify-content-center align-items-center">
            صبر کنید
        </div>
    );
}

export default Learning;